import type { ReactNode } from 'react';
import type { AssetStatus } from '../../api/types';
import { cn } from '../../lib/cn';
import { STATUS_LABELS } from '../../lib/format';

type Tone = 'gray' | 'green' | 'blue' | 'amber' | 'red' | 'violet';
const tones: Record<Tone, string> = {
  gray: 'bg-slate-100 text-slate-700 ring-slate-200',
  green: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  blue: 'bg-brand-50 text-brand-700 ring-brand-100',
  amber: 'bg-amber-50 text-amber-800 ring-amber-200',
  red: 'bg-red-50 text-red-700 ring-red-200',
  violet: 'bg-violet-50 text-violet-700 ring-violet-200',
};

export function Badge({ children, tone = 'gray', className }: { children: ReactNode; tone?: Tone; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap ring-1 ring-inset', tones[tone], className)}>
      {children}
    </span>
  );
}

const STATUS_TONES: Record<AssetStatus, Tone> = {
  active: 'green',
  in_stock: 'blue',
  repair: 'amber',
  retired: 'gray',
  disposed: 'red',
  lost: 'violet',
  unknown: 'gray',
};

export function StatusBadge({ status }: { status: AssetStatus }) {
  return <Badge tone={STATUS_TONES[status]}>{STATUS_LABELS[status]}</Badge>;
}
